


export const DataSocios = [
    {
        id: 1,
        type: "Agente",
        name: "ANGELA LEITON MEDINA",
        email: "PROVERSOPROPIEDADES@UNNE.CL",
        phone: "953608834",
        href: "https://proversopropiedades.unne.cl/",
        imgMe:""
},
{
    id: 2,
    type: "Agente",
    name: "MARIA LORENA LEON MORAPASTEN",
    email: "TRIJAVAL@UNNE.CL",
    phone: "997548637",
    href: "https://trijaval.unne.cl/",
    imgMe:""
},   
 {
    id: 3,
    type: "Agente",
    name: "PATRICIA PAMELA GONZALEZ TISKA",
    email: "PGTISKA@UNNE.CL",
    phone: "962183309",
    href: "https://pycpropiedades.unne.cl/",
    imgMe:""
},    
{
    id: 4,
    type: "Agente",
    name: "JESSICA AVILES",
    email: "javiles@unne.cl",
    phone: "988172197",
    href: "https://javiles.unne.cl/",
    imgMe:""
},
{
    id: 5,
    type: "Agente",
    name: "ROSSELLA CANO CAPPELLACCI",
    email: "PROPCM@UNNE.CL",
    phone: "992582381",
    href: "https://propcm.unne.cl/",
    imgMe:""
},
{
    id: 6,
    type: "Agente",
    name: "SANDRA VERA SILVA",
    email: "CAYSA@UNNE.CL",
    phone: "951123935",
    href: "https://caysa.unne.cl/",
    imgMe:""
},
]